import brand from '@helpers/brand';
import { fluid } from '@helpers/fluid';
import { Device, from, until } from '@helpers/media';
import { h1, paragraphSmall } from '@helpers/typography';
import SectionWrapper from '@stories/Components/SectionWrapper/SectionWrapper';
import styled from 'styled-components';
const Container = styled(SectionWrapper) `
  --bgColor: ${brand.green};
  --fgColor: ${brand.white};

  background-color: var(--bgColor);
  color: var(--fgColor);
  margin: 0;
  padding: var(--sectionSpacing) 0;

  @media ${from(Device.TabletLarge)} {
    --bgColor: ${brand.white};
    --fgColor: ${brand.black};

    margin: var(--sectionSpacing) 0;
    padding: 0;
  }
`;
const Inner = styled.div `
  border: 2px solid ${brand.green};
  margin: 0 auto;
  max-width: 1128px;
`;
const FeaturesWrapper = styled.div `
  --bgColor: ${brand.white};
  --fgColor: ${brand.black};

  display: flex;
  background-color: var(--bgColor);
  color: var(--fgColor);
  padding: ${fluid(20, 32)} ${fluid(30, 52)};
`;
const Title = styled.h2 `
  ${h1}

  margin-bottom: ${fluid(30, 48)};
  text-align: center;
`;
const BottomSection = styled.div `
  display: grid;
  grid-template-columns: 1fr;

  @media ${from(Device.TabletLarge)} {
    column-gap: 112px;
    grid-template-columns: repeat(2, 1fr);
    margin: 40px;
  }
`;
const LegalContent = styled.div `
  ${paragraphSmall}

  --bgColor: ${brand.white};
  --fgColor: ${brand.black};

  background-color: var(--bgColor);
  color: var(--fgColor);
  margin: 0;

  > * {
    margin: 0 0 1em;
  }

  @media ${until(Device.TabletLarge)} {
    padding: ${fluid(20, 32)} ${fluid(30, 52)};
  }
`;
const FinanceCalculatorStyles = {
    BottomSection,
    Container,
    FeaturesWrapper,
    Inner,
    LegalContent,
    Title,
};
export default FinanceCalculatorStyles;
